import { Component } from '@angular/core';
import { FrequentAccessCardData } from 'src/app/common-components/cards/frequent-access-card/frequent-access-card.types';
import { ScheduleCardData } from 'src/app/common-components/cards/schedule-card/schedule-card.types';

@Component({
  selector: 'app-card-playground',
  templateUrl: './card-playground.component.html',
  styleUrls: ['./card-playground.component.scss'],
})
export class CardPlaygroundComponent {
  title = 'Título de la tarjeta';
  subtitle = 'Subtítulo opcional';
  body = 'Contenido reusable para componentes que requieren contenedores tipo card.';

  frequentAccessCard: FrequentAccessCardData = {
    title: 'Acceso frecuente',
    accessType: 'Proveedor',
    dateText: 'Lun - Vie',
  };

  scheduleCard: ScheduleCardData = {
    dayLabel: 'Lunes',
    slots: [
      { fromLabel: 'Desde: 08:00', toLabel: 'Hasta: 12:00' },
      { fromLabel: 'Desde: 14:00', toLabel: 'Hasta: 18:00' },
    ],
  };
}
